import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import { action, makeObservable } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'

import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import StagedForm from './StagedForm'
import Spinner from '../../../UniformComponents/Spinner'
import { unescapeHtmlTags, stripOutHtml } from '../../helpers'

@observer
class DataSetup extends PureComponent {
    fields={}

    constructor(props) {
        super(props)
        makeObservable(this)
        const { dashboardWizardStore } = props
        this.state = {
            openAccordian: false,
        }
        dashboardWizardStore.initDataSetup()
        if (dashboardWizardStore.detailedQuestions.length === 1) {
            const [question] = dashboardWizardStore.detailedQuestions
            this.onChange(question, 'questionId')
            this.onChange({ value: question.parentId }, 'parentQuestion')
            this.onChange({ value: question.questionTypeCode }, 'questionTypeCode')
            this.onChange({ value: question }, 'question')
            this.setIsNumeric(question)
        }
    }

    controls = () => {
        const { dashboardWizardStore } = this.props
        const { openAccordian } = this.state
        return [
            {
                name: 'questionId',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.selectQuestionLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.selectQuestionTooltip'),
                options: (store) => store.detailedQuestions,
                onChange: (v) => {
                    this.onChange(v, 'questionId')
                    this.onChange({ value: v.parentId }, 'parentQuestion')
                    this.onChange({ value: v.questionTypeCode }, 'questionTypeCode')
                    this.onChange({ value: v }, 'question')
                    this.onChange({ value: v.qlistParentId }, 'qlistParentId')
                    this.setIsNumeric(v)
                    this.setOptionFilters()
                },
                show: () => this.showSelect(['detailedQuestions']),
                isMandatory: true,
            },
            {
                name: 'displayAs',
                type: 'radio',
                label: i18n.t('dynamicDash.wizard.displayAsLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.displayAsTooltip'),
                options: (store) => R.pathOr(
                    [],
                    ['questionDisplayAs', store.newWidget.questionTypeCode, store.newWidget.isNumeric],
                    store,
                ),
                valuePath: ['newWidget', 'displayAs'],
                onChange: (v) => {
                    dashboardWizardStore.setDisplayAs(v)
                    this.setOptionFilters()
                },
                isMandatory: true,
                dontAutoSet: true,
            },
            {
                name: 'dataLevel',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.dataLevelLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.dataLevelTooltip'),
                options: (store) => R.pathOr([], ['dataLevels'], store),
                onChange: (v) => { this.changeDataLevel(v, 'dataLevel') },
                isMandatory: true,
                show: () => this.showSelect(['dataLevels']),
            },
            {
                name: 'timePeriod',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.timePeriodLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.timePeriodTooltip'),
                options: (store) => {
                    const { dashStore } = store
                    const { oId } = dashStore
                    return oId === 6 ? [
                        { value: 'YOY', label: 'Year On Year' },
                    ]
                        : R.pathOr([], ['timePeriodOptions', store.newWidget.dataLevel], store)
                },
                onChange: (v) => { this.onChange(v, 'timePeriod') },
                isMandatory: true,
                show: () => this.showTimePeriod(),
            },
            {
                name: 'optionsAccordion',
                title: i18n.t('dynamicDash.wizard.optionalSettings'),
                type: 'accordion',
                isOpen: openAccordian,
                toggleOpen: () => this.setState({ openAccordian: !openAccordian }),
                show: (store) => {
                    if (!store.newWidget.dataLevel) return 0
                    return 2
                },
                id: 1,
            },
            {
                name: 'optionFilter',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.optionFiltersLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.optionFiltersTooltip'),
                options: () => this.getQuestionOptions(),
                onChange: (v) => { this.onChange(v, 'optionFilter') },
                isMandatory: false,
                dontAutoSet: true,
                isMulti: true,
                show: (store) => {
                    if (store.newWidget.displayAs !== 'pct') return 0
                    return 2
                },
                accordionId: 1,
            },
            {
                name: 'filter',
                type: 'treeViewSelect',
                label: i18n.t('dynamicDash.wizard.optionalFiltersLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.optionalFiltersTooltip'),
                options: (store) => {
                    store.createTreeData(
                        R.pathOr([], ['newWidget', 'dataLevel'], store),
                        R.pathOr([], ['newWidget', 'filter'], store),
                    )

                    return store.filterTree
                },
                onChange: (v) => { this.onChange(v, 'filter') },
                show: (store) => {
                    if (store.newWidget.dataLevel === 'client') return 0
                    if (store.dashStore.oId === 6) return 0
                    if (!store.newWidget.dataLevel) return 0
                    return 2
                },
                validate: (({ value }) => !!value.length),
                accordionId: 1,
            },
            process.env.USE_CUSTOM_BENCHMARKS === 'true' ? {
                name: 'customTag',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.groupByLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.groupByTooltip'),
                options: (store) => [
                    { label: 'None', value: 0, tagOptions: [] },
                    ...store.benchmarkTags.map((b) => (
                        {
                            value: b.customTagId,
                            label: b.parentTagName || b.customTagName,
                            tagOptions: b.tagOptions,
                        }
                    )),
                ],
                onChange: (v) => {
                    this.onChange(v || undefined, 'customTag')
                    this.onChange({
                        value: v.tagOptions.map((b) => {
                            const tagOptionConfig = JSON.parse(b.tagOptionConfig)
                            const label = tagOptionConfig.name || tagOptionConfig.langs.en_GB
                            return (
                                { value: b.tagOptionId, label }
                            )
                        }),
                    }, 'tagOptions')
                },
                dontAutoSet: true,
                isMandatory: false,
                show: (store) => {
                    if (!store.benchmarkTags.length) return 0
                    if (store.dashStore.oId === 6) return 0
                    if (!store.newWidget.dataLevel) return 0
                    return 2
                },
                accordionId: 1,
            } : undefined,
            process.env.USE_CUSTOM_BENCHMARKS === 'true' ? {
                name: 'tagOptions',
                type: 'select',
                label: i18n.t('dynamicDash.wizard.customFiltersLabel'),
                tooltipText: i18n.t('dynamicDash.wizard.customFiltersTooltip'),
                options: (store) => {
                    const customTag = store.benchmarkTags
                        .find((b) => b.customTagId === R.pathOr(undefined, ['customTag'], store.newWidget))
                    return R.pathOr([], ['tagOptions'], customTag)
                        .map((b) => (
                            { value: b.tagOptionId, label: JSON.parse(b.tagOptionConfig).name }
                        ))
                },
                isMulti: true,
                onChange: (v) => {
                    this.onChange(v, 'tagOptions')
                },
                dontAutoSet: true,
                isMandatory: false,
                show: (store) => {
                    if (!store.newWidget.customTag) return 0
                    if (!store.benchmarkTags.length) return 0
                    if (store.dashStore.oId === 6) return 0
                    if (!store.newWidget.dataLevel) return 0
                    return 2
                },
                accordionId: 1,
            } : undefined,
        ]
    }

    @action
    setDefaults = () => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget, getQuestions } = dashboardWizardStore
        this.controls().forEach((c) => {
            const options = c.options ? c.options(dashboardWizardStore) : []
            if (options.length === 1 && !c.dontAutoSet && c.name !== 'filter') {
                changeNewWidget(options[0].value, c.name)
                if (c.name === 'productType') getQuestions()
            }
        })
    }

    setOptionFilters = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget } = dashboardWizardStore
        if (newWidget.displayAs !== 'pct') {
            this.onChange({ value: [] }, 'optionFilter')
            return
        }
        this.onChange({ value: this.getQuestionOptions() }, 'optionFilter')
    }

    onChange = async ({ value }, field) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget, getQuestions, newWidget } = dashboardWizardStore
        changeNewWidget(value, field)
        this.setDefaults()
        if (newWidget.respondentType && newWidget.productType && field === 'productType') {
            await getQuestions()
        }
    }

    changeDataLevel = (v, field) => {
        const { dashboardWizardStore } = this.props
        dashboardWizardStore.createTreeData(
            v.value,
            R.pathOr([], ['newWidget', 'filter'], dashboardWizardStore),
        )
        this.onChange(v, field)
    }

    getQuestionOptions = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, appStore, getQuestionLabel } = dashboardWizardStore
        const { question } = newWidget
        const { langcode } = appStore

        if (!question) return []
        const { questionTypeCode } = question

        const questionPath = questionTypeCode.includes('TB')
            ? ['optionSetX', 'options']
            : ['optionSet', 'options']

        const options = R.pathOr([], questionPath, question)

        return options.map((o) => ({
            value: R.pathOr('', ['id'], o),
            label: unescapeHtmlTags(stripOutHtml(getQuestionLabel(
                question,
                langcode,
                R.pathOr({}, ['langs'], o),
                false,
            ))),
        }))
    }

    setIsNumeric = (q) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget, dashStore } = dashboardWizardStore
        const { oId } = dashStore
        if (['I', 'NF', 'NF - row', 'FM', 'PC', 'OD', 'OD - row'].includes(q.questionTypeCode)) return changeNewWidget('numeric', 'isNumeric')
        if (['RD'].includes(q.questionTypeCode)) {
            if (q.settings.frontend.renderNPS || R.pathOr('', ['metadata', 'kpiType'], q) === 'NPS') return changeNewWidget('nps', 'isNumeric')
            return changeNewWidget(q.optionSet.hasNumericCodes ? 'numeric' : 'nonNumeric', 'isNumeric')
        }
        if (['CH', 'SB', 'OD'].includes(q.questionTypeCode)) {
            return changeNewWidget(q.optionSet.hasNumericCodes ? 'numeric' : 'nonNumeric', 'isNumeric')
        }
        if (['TB', 'TB - row'].includes(q.questionTypeCode)) return changeNewWidget(q.optionSetX.hasNumericCodes ? 'numeric' : 'nonNumeric', 'isNumeric')
        if (['SG'].includes(q.questionTypeCode)) return changeNewWidget(oId === 6 ? 'numericEvent' : 'numeric', 'isNumeric')
        return ''
    }

    showSelect = (options) => {
        const { dashboardWizardStore } = this.props
        const storeOptions = R.pathOr([], options, dashboardWizardStore)
        if (storeOptions.length > 1) {
            return 2
        }
        if (storeOptions.length === 1) {
            return 1
        }
        return 1
    }

    showTimePeriod = () => {
        const { dashboardWizardStore } = this.props
        if (dashboardWizardStore.dashStore.oId === 6) return 1
        if (!dashboardWizardStore.newWidget.dataLevel) return 1
        return 2
    }

    register = (name, validate) => {
        this.fields[name] = validate
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    complete = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, nextStage } = dashboardWizardStore
        const valid = Object.keys(this.fields).reduce((isValid, f) => {
            const currentValid = this.fields[f]({ value: newWidget[f], name: f }, true)
            if (!isValid || !currentValid) return false
            return true
        }, true)
        if (valid) nextStage()
    }

    render() {
        const { dashboardWizardStore } = this.props
        const {
            detailedQuestions, previousStage, loading, loadingQuestions,
        } = dashboardWizardStore
        const { openAccordian } = this.state
        if (loading || loadingQuestions) return <Spinner />
        if (!detailedQuestions.length) {
            return (
                <div className="noQuestionsFound">
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        No questions could be found for
                        the selected options. Please click back and try again
                    </div>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ margin: '20px auto', width: '134px' }}
                        onClick={previousStage}
                    />
                </div>
            )
        }
        return (
            <div className="eventSetup">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        Data Setup
                    </div>
                    <div className="subTitle">
                        Enter your event requirements below
                    </div>
                </ModalHeader>
                <div className="body">
                    <StagedForm
                        store={dashboardWizardStore}
                        controls={this.controls().filter((c) => !!c)}
                        valueHolder={dashboardWizardStore.newWidget}
                        register={this.register}
                        unregister={this.unregister}
                    />
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Continue"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.complete}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default DataSetup
